/**
 * SATELLAI Collection 场景切换组件。
 * 只管理当前 section 内的 Tabs，不监听滚动，不依赖 Alpine.js。
 */
(() => {
  class SatellaiTrackerShowcase extends HTMLElement {
    constructor() {
      super();
      this.tabs = [];
      this.panels = [];
      this.handleClick = this.handleClick.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);
    }

    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

      if (this.tabs.length === 0) return;

      this.addEventListener('click', this.handleClick);
      this.addEventListener('keydown', this.handleKeydown);

      const selectedIndex = this.tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');
      this.activateTab(selectedIndex >= 0 ? selectedIndex : 0, false);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      this.removeEventListener('keydown', this.handleKeydown);
    }

    handleClick(event) {
      const tab = event.target.closest('[role="tab"]');
      if (!tab || !this.contains(tab)) return;

      const index = this.tabs.indexOf(tab);
      if (index >= 0) this.activateTab(index, true);
    }

    handleKeydown(event) {
      const currentTab = event.target.closest('[role="tab"]');
      if (!currentTab || !this.contains(currentTab)) return;

      const currentIndex = this.tabs.indexOf(currentTab);
      let nextIndex = currentIndex;

      if (event.key === 'ArrowRight') {
        nextIndex = (currentIndex + 1) % this.tabs.length;
      } else if (event.key === 'ArrowLeft') {
        nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
      } else if (event.key === 'Home') {
        nextIndex = 0;
      } else if (event.key === 'End') {
        nextIndex = this.tabs.length - 1;
      } else {
        return;
      }

      event.preventDefault();
      this.activateTab(nextIndex, true);
    }

    activateTab(activeIndex, focusTab) {
      this.tabs.forEach((tab, index) => {
        const isActive = index === activeIndex;
        tab.setAttribute('aria-selected', String(isActive));
        tab.tabIndex = isActive ? 0 : -1;
      });

      this.panels.forEach((panel, index) => {
        panel.hidden = index !== activeIndex;
      });

      if (focusTab) this.tabs[activeIndex]?.focus();
    }
  }

  if (!customElements.get('satellai-tracker-showcase')) {
    customElements.define('satellai-tracker-showcase', SatellaiTrackerShowcase);
  }
})();
